




































import BaseInput from "../models/base.input";
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator';
import { EventBus } from '@/event-bus';
@Component({
    props: ['rangeProperties', 'validate']
})
export default class DateRange extends BaseInput {  
    @Prop()
    rangeProperties :any;   
    @Prop()
    value :any;    

    lang: string = 'ru';
    
    created() {            
      this.parentValidator.extend("dateRangeRequired", this.dateRangeRequired);      
      this.lang = (localStorage.lang || 'Ru').toLowerCase();
      EventBus.$on('lang-changed', (lang: string) => {
        this.lang = lang;
      });
    }

    get customValidation() {
      return this.validate == 'required' ? 'dateRangeRequired' : this.validate;
    }

    dateRangeRequired = {
      validate(value: any, args: any) {        
        return !!(value && value[0] && value[1]);
      } 
    }
}
